    <div class="surface-card  border-solid border-1 border-bottom-none mt-4 px-4 py-2 md:px-6 lg:px-8"  style="border-color: #3e3e3e">
    	<h2 class="m-0 p-0 py-2">Mes commandes sauvegardées <i class="pi pi-refresh cursor-pointer" (click)="refreshSavedOrders()"></i></h2>
    </div>
    <p-table #dt [value]="savedOrders" styleClass="p-datatable-gridlines w-full" [loading]="api.loading">
    	<ng-template pTemplate="header">
    		<tr>
                <th *ngIf="api.adminOrder">Client</th>
    			<th *ngIf="api.adminOrder">Commercial</th>
    			<th class="w-12rem">Date</th>
    			<th class="w-10rem">Montant</th>
    			<th>Produits</th>
    			<th class="w-8rem"></th>
    		</tr>
            <tr *ngIf="api.adminOrder">
              <th>
                <input pInputText type="text" placeholder="Filtrer par Client" (input)="dt.filter($event.target.value, 'order.customer.Name', 'contains')">
              </th>
              <th>
                <input pInputText type="text" placeholder="Filtrer par Commercial" (input)="dt.filter($event.target.value, 'order.customer.ColleagueId', 'contains')">
              </th>
            </tr>
    	</ng-template>
    	<ng-template pTemplate="body" let-row>
    		<tr class="">
                <td *ngIf="api.adminOrder && row.order.customer">{{row.order.customer.Name}}</td>
    			<td *ngIf="api.adminOrder && row.order.customer">{{row.order.customer.ColleagueId}}</td>
    			<td class="white-space-nowrap">{{row.date_add | date:'short'}}</td>
    			<td>{{row.order.sumTTC | currency:'EUR'}}</td>
    			<td class="cursor-pointer white-space-nowrap overflow-hidden text-overflow-ellipsis " style="max-width: 0;" (click)="op.toggle($event)">
    				<span *ngFor="let item of row.order.prods">{{item.name}} x {{item.quantity}}, </span>
    				<p-overlayPanel #op [showCloseIcon]="true">
    					<ng-template pTemplate>
    						<div *ngFor="let item of row.order.prods">{{item.name}} x {{item.quantity}} </div>
    					</ng-template>
    				</p-overlayPanel>

    			</td>
    			<td>
    				<button tooltipPosition="left" pTooltip="Charger la commande" (click)="chargeOrder(row)" pButton pRipple icon="pi pi-download" class=" p-button-text p-button-rounded"></button>
    				<button tooltipPosition="left" pTooltip="Supprimer la commande" (click)="delete(row)" pButton pRipple icon="pi pi-trash" class="p-button-danger p-button-text p-button-rounded"></button>
    			</td>
    		</tr>
    	</ng-template>
    	<ng-template pTemplate="emptymessage" let-columns>
    		<tr>
    			<td [attr.colspan]="4">
    				Vous n'avez pas de commandes sauvegardées
    			</td>
    		</tr>
    	</ng-template>
    </p-table>